// extracted by mini-css-extract-plugin
export default {"container":"PatrolsRewardsListDialog-module_container_b819d"};